import {Component, Input} from '@angular/core';
import {IdName} from '@core/src/lib/models/id-name.model';

@Component({
  selector: 'si-inter-intervention-item',
  templateUrl: './inter-intervention-item.component.html',
  styleUrls: ['./inter-intervention-item.component.scss']
})
export class InterInterventionItemComponent {
  @Input() interventionId: number;
  @Input() admissionDate: number;
  @Input() interventionDate: number;
  @Input() centerName: string;
  @Input() professionalName: string;
  @Input() serviceName: string;
  @Input() procedures: IdName[];
  @Input() forceMobile: false;
}
